import { LobbyNicknamePage } from '@hendrx/core/plenary/pages/LobbyNicknamePage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/lobby/signup')({
  component: LobbyNicknamePage
});
